import { useRouter } from '@/navigation';
import { useMatchGroups } from '@/hooks/query/golden-duel/use-golden-duel-match-group';
import { fetchGetMarketByLeagueOrMatch } from '@/hooks/use-galaxy-deeplink-params';
import { useSiteStore } from '@/store/site';
import { useAuthToken } from '@/store/auth';
import { useMemo } from 'react';

interface Match {
	HomeFtScore?: number | null;
	MatchId: number;
}

export const useGoldenDuelNavigation = (enabled = true) => {
	const router = useRouter();
	const { data: matchGroups } = useMatchGroups(
		{ filterType: 0, drawTime: '' }, 
		{ enabled }
	);
	const authToken = useAuthToken();
	const apiDomain = useSiteStore(state => state.apiDomain.ctcdDomain);

	// Get all undrawn match IDs
	const undrawnMatchIds = useMemo(() => {
		return matchGroups?.Data?.flatMap(group => 
			group.Matches?.filter((match: Match) => 
				match.HomeFtScore === undefined || match.HomeFtScore === null
			).map(match => match.MatchId) || []
		) || [];
	}, [matchGroups?.Data]);

	const navigateToFirstUndrawnMatch = async () => {
		if (!undrawnMatchIds.length) return;
		
		// Get market for basketball playoffs
		const market = await fetchGetMarketByLeagueOrMatch({
			apiDomain,
			market: '',
			leagueId: 0,
			matchId: undrawnMatchIds[0],
			authToken: authToken
		});

		// Navigate to odds page with correct market
		router.push(`/sports/2/${market}`);
	};

	return {
		navigateToFirstUndrawnMatch,
		undrawnMatchIds,
		hasAvailableMatch: undrawnMatchIds.length > 0
	};
}; 